// extracted by mini-css-extract-plugin
export default {"CreditCard":"RUViVDkG","Details":"L82DLzxD","MakeDefaultButton":"v6oukub0","isDefault":"VGkQFDmH","DeleteButton":"eNUAYX63","isDark":"e0K_0Q7s"};